import createReducer from 'common/redux/utils/createReducer';
import keyBy from 'lodash.keyby';
import { Map, List } from 'immutable';
import {
  REQUEST_THREADS,
  RECEIVE_THREADS,
  FILTER_THREADS,
  FILTER_UNREAD_THREADS,
  FILTER_STARED_THREADS,
  THREAD_STARED,
} from 'messaging/actions/thread';
import { MESSAGES_READ } from 'messaging/actions/mailbox';
import { SSE_MESSAGE } from 'services/sse';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  loaded: false,
  messages: new Map(),
  filterUnread: false,
  filterStared: false,
};

const sortedThreads = threads =>
  List(threads)
    .map(t => {
      return {
        ...t.message,
        lastReadIndex: t.last_read_index,
        isStared: t.is_stared,
      };
    })
    .sortBy(m => m.sent_at)
    .reverse()
    .toArray();

const threads = createReducer(initialState, {
  [REQUEST_THREADS](state, action) {
    return {
      isFetching: true,
      ...state,
    };
  },
  [RECEIVE_THREADS](state, { threads }) {
    return {
      ...state,
      isFetching: false,
      loaded: true,
      messages: Map(keyBy(sortedThreads(threads), 'user_id')),
    };
  },
  [FILTER_THREADS](state, { filter }) {
    const threadFilter = filter.trim().length ? filter : undefined;

    return {
      ...state,
      threadFilter,
    };
  },
  [FILTER_UNREAD_THREADS](state) {
    return {
      ...state,
      filterUnread: !state.filterUnread,
    };
  },
  [FILTER_STARED_THREADS](state) {
    return {
      ...state,
      filterStared: !state.filterStared,
    };
  },
  [THREAD_STARED](state, { user, isStared }) {
    return {
      ...state,
      messages: state.messages.update(user.toString(), existing => {
        return {
          ...existing,
          isStared,
        };
      }),
    };
  },
  [MESSAGES_READ](state, { user }) {
    return {
      ...state,
      messages: state.messages.update(user.toString(), existing => {
        return {
          ...existing,
          lastReadIndex: existing.index,
        };
      }),
    };
  },
  [SSE_MESSAGE](state, { event }) {
    const messages = Map(keyBy(event.content, 'user_id'));

    return {
      ...state,
      messages: state.messages.mergeWith((previous, next) => {
        return {
          ...next,
          isStared: previous.isStared,
          lastReadIndex: next.sender ? previous.lastReadIndex : next.index,
        };
      }, messages),
    };
  },
});

export default threads;



// WEBPACK FOOTER //
// ./src/modules/messaging/reducers/threads.js